const numberFormatter = new Intl.NumberFormat('en-US');
const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const currencyWholeFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export function formatNumber(value: number): string {
  return numberFormatter.format(value);
}

export function formatCurrency(value: number, showDecimals = true): string {
  return showDecimals
    ? currencyFormatter.format(value)
    : currencyWholeFormatter.format(value);
}

export function formatCurrencyRaw(value: number, showDecimals = true): string {
  return showDecimals
    ? `$${numberFormatter.format(parseFloat(value.toFixed(2)))}`
    : `$${numberFormatter.format(Math.round(value))}`;
}
